// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"874":"7949ae92","959":"3df0f6d7"}[chunkId] + ".css";
};